import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/shipment/wb'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });


export default class PostingsWbApi {

    static async getOrders({ data = { shop: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getorders', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async moveOrdersToShipment({ data = { shop: undefined, orders: undefined, supplierName: undefined, orderId: undefined, shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/orderstoshipment', method: 'POST', data, ...params })
    }




    static async deliveryOrder({ data = { shop: undefined, ordersIds: undefined, }, ...params }) {
        return await fetchService({ url: '/deliveryorder', method: 'POST', data, ...params })
    }

    static async cancelOrder({ data = { shop: undefined, ordersIds: undefined, }, ...params }) {
        return await fetchService({ url: '/cancelorder', method: 'POST', data, ...params })
    }

    static async receiveOrder({ data = { shop: undefined, ordersIds: undefined, code: undefined }, ...params }) {
        return await fetchService({ url: '/receiveorder', method: 'POST', data, ...params })
    }

    static async rejectOrder({ data = { shop: undefined, ordersIds: undefined, code: undefined }, ...params }) {
        return await fetchService({ url: '/rejectorder', method: 'POST', data, ...params })
    }



    static async getShipments({ data = { shop: undefined, skladName: undefined, isActive: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getshipments', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async createShipment({ data = { shop: undefined, name: undefined }, ...params }) {
        return await fetchService({ url: '/createshipment', method: 'POST', data, ...params })
    }

    static async deleteShipment({ data = { shop: undefined, supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/deleteshipment', method: 'DELETE', data, ...params })
    }

    static async shipSupply({ data = { shop: undefined, supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/shipsupply', method: 'POST', data, ...params })
    }

    static async loadShipmentBarcode({ data = { shop: undefined, supplyId: undefined, city: undefined }, ...params }) {
        return await fetchService({ url: '/loadbarcode', method: 'POST', data, options: { download: true }, ...params })
    }

    // static async saveForDriver({ data = { shop: undefined, supplyId: undefined, skladName: undefined }, ...params }) {
    //     return await fetchService({ url: '/savebarcodefordriver', method: 'POST', data, ...params })
    // }

    // static async getPDFqr({ data = { sklad: undefined }, ...params }) {
    //     return await fetchService({ url: '/getqrwb', method: 'GET', data, ...params })
    // }




    static async getShipmentPostings({ data = { shop: undefined, supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/getshipmentpostings', method: 'POST', data, notify: { success: false }, ...params })
    }




    // static async saveReturns({ data = { shop: undefined, file: undefined }, ...params }) {
    //     return await fetchService({ url: '/savereturns', method: 'POST', data, ...params })
    // }

    static async loadReturns({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadreturns', method: 'POST', data, ...params })
    }


}